import { getAuthState } from "utils"

export const useUsuarioPageAsideLogic = () => {
	return { authState: getAuthState() }
}
